<template>
  <v-app id="inspire">
    <v-content class="content-background">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  name: "AuthLayout"
};
</script>
<style  scoped>
.content-background {
  background-color: rgba(237, 246, 255) !important;
}
</style>



